import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { InfoDialogFacade } from 'src/app/_core/state/dialogs/info/info.facade';
import { InfoDialogItem } from 'src/app/models/info-dialog';

@Component({
  selector: 'opac-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss'],
})
export class InfoDialogComponent {
  private readonly infoDialogFacade = inject(InfoDialogFacade);

  readonly isOpen = toSignal<boolean>(this.infoDialogFacade.open$);
  readonly title = toSignal<string>(this.infoDialogFacade.title$);
  readonly description = toSignal<string>(this.infoDialogFacade.description$);
  readonly content = toSignal<InfoDialogItem[]>(this.infoDialogFacade.content$);
  readonly showActions = toSignal<boolean>(this.infoDialogFacade.showActions$);

  closeDialog() {
    this.infoDialogFacade.closeDialog();
  }
}
